import { render, staticRenderFns } from "./ProfileReposts.vue?vue&type=template&id=2a297e51"
import script from "./ProfileReposts.vue?vue&type=script&lang=js"
export * from "./ProfileReposts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports